import './Header.scss';
import { Link, useNavigate } from 'react-router-dom';
import shi_h_icon from "../../assets/Shi_icon.png";
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from "../LanguageSwitcher/LanguageSwitcher";


const Header = () => {
  const {t} = useTranslation();
  const navigate = useNavigate();
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = -90;
      // the distance between the top edge of the targetElement and the top edge of its offset parent
      window.scrollTo({
        top: element.offsetTop + offset,
        behavior: "smooth",
      });
    }
  };
  const routeChange = () => {
    const path = "/TechPage";
    navigate(path);
  }
  return (
    <div className="header">
      <div className="header__wrapper">
        <div className="header__wrapper-left">
          <Link to="/" onClick={scrollToTop}>
            <img className="header__image" src={shi_h_icon} alt="Shi.ai" />
          </Link>
          <LanguageSwitcher />
        </div>
        <nav className="header__nav">
          <div className="header__tabs">
            <div class="header__tab--container">
              <Link to="/" onClick={() => scrollToSection("about")}>
                <h4 class="header__tab">{t("header.about")}</h4>
              </Link>
            </div>
            <div class="header__tab--container">
              <Link to="/" onClick={() => scrollToSection("interests")}>
                <h4 class="header__tab">{t("header.interest")}</h4>
              </Link>
            </div>
            <div class="header__tab--container">
              <Link to="/" onClick={() => scrollToSection("career")}>
                <h4 class="header__tab">{t("header.education")}</h4>
              </Link>
            </div>
            <div class="header__tab--container">
              <Link to="/" onClick={() => scrollToSection("passion")}>
                <h4 class="header__tab">{t("header.competencies")}</h4>
              </Link>
            </div>
            <div class="header__tab--container">
              <Link to="/" onClick={() => scrollToSection("projects")}>
                <h4 class="header__tab">{t("header.projects")}</h4>
              </Link>
            </div>
            <div class="header__tab--container">
              <Link to="/" onClick={() => scrollToSection("contact")}>
                <h4 class="header__tab">{t("header.contact")}</h4>
              </Link>
            </div>
          </div>
          <button className="header__addbtn" onClick={routeChange}>
            {t("header.coding")}
          </button>
        </nav>
      </div>
    </div>
  );
};
export default Header;